import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import CustomTabs from "./tabs/CustomTabs.jsx";
import { refundOrderActions } from "../../redux/actions/index.js";
import CustomerDetail from "./components/CustomerDetail.jsx";
import OrderSummaryCard from "./components/OrderSummaryCard.jsx";
import { orderConstants } from "../../constants/order.constants.js";
import { custom } from "../../redux/actions/utilities.js";

const Refund = (props) => {
  const { order, getRefudOrders, getProductsByOrderId, refundSuccess } = props;

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    if (id) {
      getRefudOrders(id);
      getProductsByOrderId(id);
    }
  }, [id]);

  useEffect(() => {
    if (refundSuccess) {
      navigate("/");
      dispatch({ type: orderConstants.RESET_REFUND_SUCCESS });
    }
  }, [refundSuccess]);

  return (
    <div className="refund-container">
      <h1>Refund order {order.id}</h1>

      <p className="refund-description">
        <span>
          If you're unable to refund an order, you will need to log into your
          payment gateway's dashboard to process the refund.
        </span>
        <a
          href="https://support.bigcommerce.com/articles/Public/Processing-Refunds"
          target="_blank"
        >
          <span>Learn More</span>
          <icon className="share-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"></path>
            </svg>
          </icon>
        </a>
      </p>

      <div className="customer-detail">
        <div className="panel-header">
          <h2 className="panel-title">
            <span>Customer details</span>
          </h2>

          <CustomerDetail />
        </div>
      </div>

      <div>
        <div className="panel-header">
          <h2 className="panel-title">
            <span>Order summary</span>
          </h2>

          <OrderSummaryCard />
        </div>
      </div>

      <div>
        <div className="panel-header">
          <h2 className="panel-title">
            <span>Refundable items</span>
          </h2>

          <CustomTabs orderId={id} />
        </div>
      </div>
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  order: state.RefundOrder.orderData,
  productsData: state.RefundOrder.productsData,
  customer: state.RefundOrder.customerData,
  refundSuccess: state.RefundOrder.refundSuccess,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getRefudOrders: (id) => dispatch(refundOrderActions.getRefundOrders(id)),
  getProductsByOrderId: (id) =>
    dispatch(refundOrderActions.getProductsByOrderId(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Refund);
